import SplitOverlayProductMaterial3Up from './product-material-3-up/script';
import SplitOverlayProduct2Up from './product-2-up/script';
import SplitOverlayProduct3Up from './product-3-up/script';

export default {
	[SplitOverlayProductMaterial3Up.selector]: SplitOverlayProductMaterial3Up,
	[SplitOverlayProduct2Up.selector]: SplitOverlayProduct2Up,
	[SplitOverlayProduct3Up.selector]: SplitOverlayProduct3Up
};
